import {CommonResponse, BaseRequestParams, GetParamsType, GetSingleParamsType, instance} from "./API"
import {AxiosResponse} from "axios"
import {filterToString} from "../helps/filterToString"
import {PSLeakDeviceLocalLogResponse, PSLeakDeviceLocalLogsResponse} from "../models/response"

export const psLeakDeviceLocalLogApi = {
    getLogs(params?: GetParamsType & PSLeakDeviceLocalLogsFilterQuery): Promise<CommonResponse<PSLeakDeviceLocalLogsResponse>> {
        const paramsString = filterToString(params)
        return instance.get(`PSLeakDeviceLocalLog${paramsString}`, {signal: params?.controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    getLog(params: GetSingleParamsType): Promise<CommonResponse<PSLeakDeviceLocalLogResponse>> {
        const {id, controller} = params
        return instance.get(`PSLeakDeviceLocalLog/${id}`, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    updateLog(params: ChangeDeviceLocalLogType): Promise<CommonResponse<PSLeakDeviceLocalLogResponse>> {
        const {id, controller, ...rest} = params
        return instance.put(`PSLeakDeviceLocalLog/${id}`, {...rest}, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    arraySolve(params: SolveDeviceLocalLogsType): Promise<CommonResponse<boolean>> {
        const {controller, ...rest} = params
        return instance.post(`PSLeakDeviceLocalLog/solve`, {...rest}, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    deleteAll(params: DeleteDeviceLocalLogs): Promise<CommonResponse<boolean>> {
        const {idDevice, controller, password} = params
        return instance.delete(`PSLeakDeviceLocalLog/${idDevice}?password=${password}`, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
}

export type PSLeakDeviceLocalLogsFilterQuery = {
    idCompany?: number
    idObjectGroup?: number
    idObject?: number
    idDevice?: number
    status?: '-1' | '0' | '1' | '2'
    dateFrom?: string | null | undefined
    dateTo?: string | null | undefined
    search?: string
}

export type ChangeDeviceLocalLogType = {
    id: number
    comment: string
    solved: boolean | null
} & BaseRequestParams

export type SolveDeviceLocalLogsType = {
    ids: Array<number>
    comment: string
} & BaseRequestParams

export type DeleteDeviceLocalLogs = {
    idDevice: number
    password: string
} & BaseRequestParams